import * as React from "react";
import { Modal as BaseModal, Box, Button, styled } from "@mui/material";
import FileUploadComp from "./fileUploadComp";

const FileUploadModel = (props) => {
  const [files, setFiles] = React.useState([]);
  const { open, setOpen, fileUploadProps, handleUploadFile } = props;
  const handleClose = () => {
    setOpen(false);
    setFiles([]);
  };

  return (
    <div>
      <Modal
        aria-labelledby="unstyled-modal-title"
        aria-describedby="unstyled-modal-description"
        open={open}
        onClose={handleClose}
      >
        <ModalContent>
          <h4 id="keep-mounted-modal-title" className="modal-title">
            Upload Pictures
          </h4>
          <p id="keep-mounted-modal-description" className="modal-description">
            Please upload allowed number of photos only. You can preview after
            selecting images.
          </p>
          <FileUploadComp
            fileUploadProps={fileUploadProps}
            files={files}
            setFiles={setFiles}
          />

          <Box sx={{ mt: 4, display: "flex", justifyContent: "space-between", gap: 2 }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{
                borderColor: "rgba(255,255,255,0.4)",
                color: "#fff",
                fontSize: "0.85rem",
                "&:hover": {
                  borderColor: "#fff",
                  backgroundColor: "rgba(255,255,255,0.08)",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                fontSize: "0.85rem",
                fontWeight: 600,
                backgroundColor: "#fff",
                color: "#001d3d",
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                },
              }}
              onClick={async (e) => await handleUploadFile(e, files, setOpen)}
            >
              Upload
            </Button>
          </Box>
        </ModalContent>
      </Modal>
    </div>
  );
};

const Modal = styled(BaseModal)({
  position: "fixed",
  zIndex: 1300,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&.base-Modal-hidden": {
    visibility: "hidden",
  },
});

const ModalContent = styled("div")({
  width: 400,
  maxWidth: "calc(100vw - 32px)",
  fontFamily: "inherit",
  fontWeight: 500,
  textAlign: "start",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: 8,
  overflow: "hidden",
  borderRadius: "4px",
  backgroundColor: "#001d3d",
  border: "1px solid rgba(255,255,255,0.12)",
  boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
  padding: 24,
  color: "#fff",

  "& .modal-title": {
    margin: 0,
    fontSize: "1.1rem",
    fontWeight: 600,
    lineHeight: 1.5,
    marginBottom: 8,
    color: "#fff",
  },

  "& .modal-description": {
    margin: 0,
    fontSize: "0.85rem",
    lineHeight: 1.5,
    fontWeight: 400,
    color: "rgba(255,255,255,0.7)",
    marginBottom: 4,
  },
});

export default FileUploadModel;

//------------------------------component info----------------------------------------------------
// open->to open the upload doc modal
// setOpen ->setter method to open prop.true/false
// fileUploadProps ->this obj has field maxNumber
// handleUploadFile -> handleUploadFiles=(e,files,setOpen)
